const isPresent = (value) => {
  const valueType = typeof value
  switch (valueType) {
    case 'number':
      return true;
    case 'string':
      return value.trim().length;
    default:
      throw new Error(`Unsupported value type: ${valueType}`);
  }
}

export default isPresent;
